/**
 * Roguelite Weapon Compile — recompile shot1/shot2 from base weapon + modifier IDs.
 */

import type { ModeState } from '../types';
import { lookupWeapon } from '../weapons/registry';
import { applyModifiers } from './modifier-apply';

/** Recompile rogueliteShot1 and rogueliteShot2 from their base IDs + mod lists. */
export function recompileWeapons(ms: ModeState): void {
  if (ms.rogueliteShot1Base) {
    const base = lookupWeapon(ms.rogueliteShot1Base);
    ms.rogueliteShot1 = applyModifiers(base, ms.rogueliteShot1Mods);
  } else {
    ms.rogueliteShot1 = null;
  }

  if (ms.rogueliteShot2Base) {
    const base = lookupWeapon(ms.rogueliteShot2Base);
    ms.rogueliteShot2 = applyModifiers(base, ms.rogueliteShot2Mods);
  } else {
    ms.rogueliteShot2 = null;
  }
}
